import * as React from 'react'
export const SvgCircularTwitter = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={40} height={40} {...props}>
    <g fill="none">
      <circle fill="#1DA1F2" cx={20} cy={20} r={20} />
      <path
        d="M27.366 14.73a4.05 4.05 0 001.776-2.233 8.073 8.073 0 01-2.567.977 4.04 4.04 0 00-6.88 3.685 11.463 11.463 0 01-8.325-4.222 4.04 4.04 0 00-.546 2.034c0 1.399.713 2.636 1.796 3.36a4.027 4.027 0 01-1.83-.503v.05a4.041 4.041 0 003.241 3.96 3.943 3.943 0 01-1.064.142 4.02 4.02 0 01-.76-.071 4.042 4.042 0 003.772 2.804 8.107 8.107 0 01-5.015 1.728c-.326 0-.649-.018-.964-.055a11.44 11.44 0 006.19 1.814c7.43 0 11.491-6.154 11.491-11.493 0-.174-.003-.35-.01-.522a8.156 8.156 0 002.014-2.091 8.045 8.045 0 01-2.32.636z"
        fill="#FFF"
      />
    </g>
  </svg>
)
export default SvgCircularTwitter
